exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone{padding:0}.dz-image img{max-width:100%}@media (max-width:768px){.verificationNew table,.verificationNew tbody,.verificationNew td,.verificationNew th,.verificationNew thead,.verificationNew tr{display:block;width:100%}.verificationNew thead{display:none}.verificationNew tr{margin-bottom:10px;border:1px solid #ddd}.verificationNew td{display:flex;justify-content:space-between}.verificationNew td:last-child{border-bottom:none}.verificationNew td:before{content:attr(data-label);font-weight:700;text-transform:capitalize}}", ""]);

// exports
